{
  "page_title": "Anunțurile mele (V2) | Panou dealer - RO Auto Market",
  "page_description": "Gestionează anunțurile tale în sistemul V2: active, ascunse, rezervate, vândute.",
  "heading": "Anunțurile mele (sistem V2)",
  "subheading": "Gestionează starea anunțurilor tale",
  "status_info": "Schimbă statusul anunțurilor: activ, ascuns, rezervat, vândut",
  "status_active": "Activ",
  "status_active_desc": "Vizibil pentru cumpărători",
  "status_hidden": "Ascuns",
  "status_hidden_desc": "Invizibil temporar",
  "status_reserved": "Rezervat",
  "status_reserved_desc": "În curs de rezervare",
  "status_sold": "Vândut",
  "status_sold_desc": "Marcat ca vândut",
  "status_expired": "Expirat",
  "status_inactive": "Inactiv",
  "status_updated": "Status actualizat",
  "status_updated_desc": "Anunțul a fost marcat ca",
  "error": "Eroare",
  "error_update": "Nu s-a putut actualiza statusul.",
  "listing_deleted": "Anunț șters",
  "listing_deleted_desc": "Anunțul a fost șters cu succes.",
  "error_delete": "Nu s-a putut șterge anunțul.",
  "no_image": "Fără imagine",
  "sold_badge": "VÂNDUT",
  "view_listing": "Vezi anunțul",
  "edit_listing": "Editează anunțul",
  "mark_active": "Marchează ca activ",
  "hide_listing": "Ascunde anunțul",
  "mark_reserved": "Marchează ca rezervat",
  "mark_sold": "Marchează ca vândut",
  "delete_listing": "Șterge anunțul",
  "confirm_delete": "Confirmare ștergere",
  "confirm_delete_desc": "Sigur vrei să ștergi acest anunț? Această acțiune nu poate fi anulată.",
  "cancel": "Anulează",
  "delete": "Șterge",
  "promoted": "Promovat",
  "auto_promoted": "Auto-promovat",
  "verified": "Verificat",
  "filter_by_status": "Filtrează după status:",
  "all": "Toate",
  "no_listings": "Nu ai anunțuri publicate încă în sistemul V2.",
  "create_listing": "Publică un anunț",
  "no_listings_status": "Nu ai anunțuri cu statusul"
}
